// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    // apiKey: 'AIzaSyBtjCJVVC4Rf0T1jVOJPbxxR0DUSAL_AWA',
    // authDomain: 'allgive-app-25240.firebaseapp.com',
    // databaseURL: 'https://allgive-app-25240.firebaseio.com',
    // projectId: 'allgive-app-25240',
    // storageBucket: 'allgive-app-25240.appspot.com',
    // messagingSenderId: '607751483144'
    apiKey: "AIzaSyCGJg6E9WkiiIbbOhAWw_A0wSMS3YKaNBs",
    authDomain: "luk-app-8729a.firebaseapp.com",
    databaseURL: "https://luk-app-8729a.firebaseio.com",
    projectId: "luk-app-8729a",
    storageBucket: "luk-app-8729a.appspot.com",
    messagingSenderId: "892545416925",
    appId: "1:892545416925:web:7bf72489e0d9e26c"
  },
  //firebaseApiUrl: 'http://192.168.2.30:5000/luk-app-8729a/us-central1',
  firebaseApiUrl: 'https://us-central1-luk-app-8729a.cloudfunctions.net',
  serverApiUrl: 'http://localhost:3000',
  mapKey: 'AIzaSyCGJg6E9WkiiIbbOhAWw_A0wSMS3YKaNBs'
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
